import { STAT_IDS } from './stats';

export const RELATED_STATS = {
    [ STAT_IDS.AFL_FANTASY_POINTS ]: [
        STAT_IDS.KICKS,
        STAT_IDS.HANDBALLS,
        STAT_IDS.MARKS,
    ],
    [ STAT_IDS.GOALS ]: [
        STAT_IDS.BEHINDS,
        STAT_IDS.SHOTS_AT_GOAL,
        STAT_IDS.GOAL_ACCURACY,
    ],
    [ STAT_IDS.GOAL_ASSIST ]: [
        STAT_IDS.GOALS,
        STAT_IDS.INSIDE_50S,
        STAT_IDS.SCORE_INVOLVEMENTS,
    ],
    [ STAT_IDS.GOAL_ACCURACY ]: [
        STAT_IDS.GOALS,
        STAT_IDS.BEHINDS,
        STAT_IDS.SHOTS_AT_GOAL,
    ],
    [ STAT_IDS.SHOTS_AT_GOAL ]: [
        STAT_IDS.GOALS,
        STAT_IDS.BEHINDS,
        STAT_IDS.GOAL_ACCURACY,
    ],
    [ STAT_IDS.BEHINDS ]: [
        STAT_IDS.GOALS,
        STAT_IDS.GOAL_ACCURACY,
    ],
    [ STAT_IDS.DISPOSALS ]: [
        STAT_IDS.KICKS,
        STAT_IDS.HANDBALLS,
        STAT_IDS.DISPOSAL_EFFICIENCY,
    ],
    [ STAT_IDS.MARKS ]: [
        STAT_IDS.CONTESTED_MARKS,
        // STATS_LEADERS_COLUMN_IDS.UNCONTESTED_MARKS, // TODO: This doesn't exist - awaiting feedback from client on how to handle this.
        STAT_IDS.INTERCEPT_MARKS,
    ],
    [ STAT_IDS.CONTESTED_MARKS ]: [
        STAT_IDS.MARKS,
        STAT_IDS.INTERCEPT_MARKS,
        STAT_IDS.MARKS_INSIDE_50,
    ],
    [ STAT_IDS.MARKS_INSIDE_50 ]: [
        STAT_IDS.MARKS,
        STAT_IDS.MARKS_ON_LEAD,
    ],
    [ STAT_IDS.MARKS_ON_LEAD ]: [
        STAT_IDS.MARKS,
        STAT_IDS.MARKS_INSIDE_50,
    ],
    [ STAT_IDS.INTERCEPT_MARKS ]: [
        STAT_IDS.MARKS,
        STAT_IDS.SPOILS,
        STAT_IDS.CONTESTED_DEFENSIVE_ONE_ON_ONES,
    ],
    [ STAT_IDS.TACKLES ]: [
        STAT_IDS.TACKLES_INSIDE_50,
        STAT_IDS.PRESSURE_ACTS,
    ],
    [ STAT_IDS.TACKLES_INSIDE_50 ]: [
        STAT_IDS.TACKLES,
        STAT_IDS.MARKS_ON_LEAD,
    ],
    [ STAT_IDS.PRESSURE_ACTS ]: [
        STAT_IDS.TACKLES,
        STAT_IDS.ONE_PERCENTERS,
    ],
    [ STAT_IDS.DEFENSIVE_HALF_PRESSURE_ACTS ]: [
        STAT_IDS.PRESSURE_ACTS,
        STAT_IDS.TACKLES,
        STAT_IDS.SPOILS,
    ],
    [ STAT_IDS.CONTESTED_DEFENSIVE_ONE_ON_ONES ]: [
        STAT_IDS.CONTESTED_DEFENSIVE_LOSSES,
        STAT_IDS.CONTESTED_DEFENSIVE_LOSS_PERCENT,
        STAT_IDS.SPOILS,
    ],
    [ STAT_IDS.CONTESTED_DEFENSIVE_LOSSES ]: [
        STAT_IDS.CONTESTED_DEFENSIVE_ONE_ON_ONES,
        STAT_IDS.CONTESTED_DEFENSIVE_LOSS_PERCENT,
        STAT_IDS.SPOILS,
    ],
    [ STAT_IDS.CONTESTED_DEFENSIVE_LOSS_PERCENT ]: [
        STAT_IDS.CONTESTED_DEFENSIVE_ONE_ON_ONES,
        STAT_IDS.CONTESTED_DEFENSIVE_LOSS_PERCENT,
        STAT_IDS.SPOILS,
    ],
    [ STAT_IDS.CLEARANCES ]: [
        STAT_IDS.CENTRE_CLEARANCES,
        STAT_IDS.STOPPAGE_CLEARANCES,
    ],
    [ STAT_IDS.KICKS ]: [
        STAT_IDS.EFFECTIVE_KICKS,
        STAT_IDS.KICK_EFFICIENCY,
        STAT_IDS.KICK_TO_HANDBALL_RATIO,
    ],
    [ STAT_IDS.HANDBALLS ]: [
        STAT_IDS.KICK_TO_HANDBALL_RATIO,
    ],
    [ STAT_IDS.HIT_OUTS ]: [
        STAT_IDS.RUCK_CONTESTS,
        STAT_IDS.HITOUTS_TO_ADVANTAGE,
        STAT_IDS.HITOUT_WIN_PERCENTAGE,
    ],
    [ STAT_IDS.FREES_FOR ]: [
        STAT_IDS.TACKLES,
        STAT_IDS.PRESSURE_ACTS,
    ],
    [ STAT_IDS.FREES_AGAINST ]: [],
    [ STAT_IDS.BOUNCES ]: [
        STAT_IDS.METRES_GAINED,
    ],
    [ STAT_IDS.ONE_PERCENTERS ]: [
        STAT_IDS.TACKLES,
        STAT_IDS.PRESSURE_ACTS,
        STAT_IDS.SPOILS,
    ],
    [ STAT_IDS.TIME_ON_GROUND ]: [],
    [ STAT_IDS.INSIDE_50S ]: [
        STAT_IDS.SCORE_INVOLVEMENTS,
        STAT_IDS.GOAL_ASSIST,
        STAT_IDS.SHOTS_AT_GOAL,
    ],
    [ STAT_IDS.DISPOSAL_EFFICIENCY ]: [
        STAT_IDS.KICK_EFFICIENCY,
        STAT_IDS.KICK_TO_HANDBALL_RATIO,
    ],
    [ STAT_IDS.CLANGERS ]: [],
    [ STAT_IDS.REBOUND_50S ]: [
        STAT_IDS.BOUNCES,
        STAT_IDS.METRES_GAINED,
        STAT_IDS.INTERCEPT_POSSESSIONS,
    ],
    [ STAT_IDS.EFFECTIVE_KICKS ]: [
        STAT_IDS.KICKS,
        STAT_IDS.KICK_EFFICIENCY,
    ],
    [ STAT_IDS.KICK_EFFICIENCY ]: [
        STAT_IDS.KICKS,
        STAT_IDS.EFFECTIVE_KICKS,
    ],
    [ STAT_IDS.KICK_TO_HANDBALL_RATIO ]: [
        STAT_IDS.KICKS,
        STAT_IDS.HANDBALLS,
        STAT_IDS.DISPOSAL_EFFICIENCY,
    ],
    [ STAT_IDS.EFFECTIVE_DISPOSALS ]: [
        STAT_IDS.EFFECTIVE_KICKS,
        STAT_IDS.KICK_TO_HANDBALL_RATIO,
    ],
    [ STAT_IDS.SPOILS ]: [
        STAT_IDS.INTERCEPT_MARKS,
        STAT_IDS.CONTESTED_DEFENSIVE_ONE_ON_ONES,
        STAT_IDS.CONTESTED_DEFENSIVE_LOSS_PERCENT,
    ],
    [ STAT_IDS.CONTESTED_POSSESSIONS ]: [
        STAT_IDS.DISPOSALS,
        STAT_IDS.CONTESTED_POSSESSION_RATE,
    ],
    [ STAT_IDS.UNCONTESTED_POSSESSIONS ]: [
        STAT_IDS.DISPOSALS,
        STAT_IDS.CONTESTED_POSSESSION_RATE,
    ],
    [ STAT_IDS.INTERCEPT_POSSESSIONS ]: [
        STAT_IDS.INTERCEPT_MARKS,
    ],
    [ STAT_IDS.TURNOVERS ]: [],
    [ STAT_IDS.CONTESTED_POSSESSION_RATE ]: [
        STAT_IDS.DISPOSALS,
        STAT_IDS.CONTESTED_POSSESSIONS,
    ],
    [ STAT_IDS.GROUND_BALL_GETS ]: [
        STAT_IDS.FWD_50_GROUND_BALL_GETS,
        STAT_IDS.GOALS,
    ],
    [ STAT_IDS.FWD_50_GROUND_BALL_GETS ]: [
        STAT_IDS.GROUND_BALL_GETS,
        STAT_IDS.GOALS,
    ],
    [ STAT_IDS.CENTRE_CLEARANCES ]: [
        STAT_IDS.CENTRE_BOUNCE_ATTENDANCES,
    ],
    [ STAT_IDS.STOPPAGE_CLEARANCES ]: [
        // STATS_LEADERS_COLUMN_IDS.STOPPAGES, // TODO: This doesn't exist - awaiting feedback from client on how to handle this.
    ],
    [ STAT_IDS.TOTAL_CLEARANCES ]: [
        STAT_IDS.CENTRE_CLEARANCES,
        STAT_IDS.STOPPAGE_CLEARANCES,
    ],
    [ STAT_IDS.HITOUTS_TO_ADVANTAGE ]: [
        STAT_IDS.RUCK_CONTESTS,
        STAT_IDS.HIT_OUTS,
        STAT_IDS.HITOUTS_TO_ADVANTAGE_PERCENTAGE,
    ],
    [ STAT_IDS.HITOUTS_TO_ADVANTAGE_PERCENTAGE ]: [
        STAT_IDS.RUCK_CONTESTS,
        STAT_IDS.HIT_OUTS,
        STAT_IDS.HITOUTS_TO_ADVANTAGE,
    ],
    [ STAT_IDS.HITOUT_WIN_PERCENTAGE ]: [
        STAT_IDS.RUCK_CONTESTS,
        STAT_IDS.HIT_OUTS,
        STAT_IDS.HITOUTS_TO_ADVANTAGE_PERCENTAGE,
    ],
    [ STAT_IDS.RUCK_CONTESTS ]: [
        STAT_IDS.HIT_OUTS,
        STAT_IDS.HITOUTS_TO_ADVANTAGE,
        STAT_IDS.HITOUTS_TO_ADVANTAGE_PERCENTAGE,
    ],
    [ STAT_IDS.SCORE_INVOLVEMENTS ]: [
        STAT_IDS.GOALS,
        STAT_IDS.GOAL_ASSIST,
    ],
    [ STAT_IDS.SCORE_LAUNCHES ]: [
        STAT_IDS.GOALS,
        STAT_IDS.SCORE_INVOLVEMENTS,
        STAT_IDS.GOAL_ASSIST,
    ],
};